module.exports = __webpack_public_path__ + "static/mako-c66659ee51ecf166eeaa57510cc75771.jpg";